define(['moduler'], function (Moduler) {
    'use strict';
    /*
        helps navigate through a two-level navigation with the keyboard
    */
    return Moduler.create({
        defaults: {
            parentSelector: '.PageNavItem-parent',
            childSelector: '.PageNav-sub'
        },
        init: function () {

            function off(element) {
                if (element) {
                    element.style.display = null;
                }
            }
            function toggle(element) {
                if (element) {
                    if (element.style.display == 'block') {
                        element.style.display = null;
                    } else {
                        element.style.display = 'block';
                    }
                }
            }
            let self = this;

            function allSubs() {
                return document.querySelectorAll(self.options.childSelector);
            }

            document.querySelectorAll(self.options.parentSelector).forEach(parent => {
                parent.addEventListener('mouseover', function (e) {
                    allSubs().forEach(sub => {
                        off(sub);
                    });
                });
            });

            window.addEventListener('keyup', function (e) {
                
                if (e.key == 'Enter') {
                    if (e.target.matches(self.options.parentSelector)) {
                        toggle(e.target.querySelector(self.options.childSelector));
                    }
                }

                if (e.key == 'Escape') {
                    let currentMenu = e.target.closest(self.options.childSelector);
                    if (currentMenu) {
                        off(currentMenu);
                        let parent = e.target.closest(self.options.parentSelector);
                        if (parent) {
                            parent.focus();
                        }   
                    }
                    if (e.target.matches(self.options.parentSelector)) {
                        off(e.target.querySelector(self.options.childSelector));
                    }
                }

                if (e.key == 'Tab') {
                    if (!e.target.closest(self.options.childSelector)) {
                        allSubs().forEach(sub => {
                            off(sub);
                        });
                    }
                }

            });
        }
    });
});
